// import Slick Slider JS
import jQuery from "jquery";

jQuery(document).ready(function ($) {});
